<script>
	import Post from "./Post.svelte";
	import { store } from "../store.js";
	import Social from "./Social.svelte";

	let deux_colonnes =
		$store.options[$$props.id].filtres.deux_colonnes === "1" ? true : false;
	// console.log(deux_colonnes);
</script>

<div
	class="cs_post_grid {deux_colonnes ? 'cs_post_grid_2cols ' : ''} {$store
		.options[$$props.id].loading == 'true'
		? 'loading'
		: 'loaded'}"
>
	{#if $store.posts[$$props.id].cg_posts && $store.posts[$$props.id].post_count > 0}
		{#each $store.posts[$$props.id].cg_posts as post, i}
			{#if $store.options[$$props.id].afficher_reseaux_sociaux == true && i == 5}
				<Social />
			{/if}
			<Post {post} id={$$props.id} />
		{/each}
	{:else if $store.posts[$$props.id].post_count == 0}
		<p class="cs_nopublications cs_message">
			Aucune publication ne correspond à vos filtres
		</p>
	{/if}
</div>
